import React from 'react'
import '../assets/style.css'
import image from '../assets/images/bg3.jpg'
import {Link, useNavigate} from 'react-router-dom'
import UseFetch from '../hooks/useFetch'
import {useEffect} from 'react'

interface Product{
category:Number
created_at:Date
description:string
id:string
images:{ image: string }[]
name:string
owner:Number
price:string
image:string

}
function NewArival() {
  const {data,getData} = UseFetch()
  const navigate = useNavigate()
  const currentpath = window.location.pathname

  useEffect(() => {
    if (data.length === 0) {
      const fetchData = async () => {
        await getData();
      };

      fetchData();
    }
  }, [getData, data]);

  const title = (<div className='header'><h4>Organic Food</h4>
  <h1 className='head'>New Arrivals</h1></div> 
  )
  return (
    <div className='newArival'>
       {currentpath ==='/' ? title  : ''} 
        <div className='products'>
        {data.map((item:Product) =>(
              <Link to={`/detail/${item.id}`} key={item.id}>
              <div className='product' >
                <img className='productImage' src={`https://djangodrf.arifsultani291.digital/products//${item.images[0].image}`}/>
                <div>
                <h3 className='productName' >{item.name}</h3>
                <p className='productPrice'>${item.price}</p>
                </div>
              </div>
              </Link>
          ))}
      
        </div>
    </div>
  )
}

export default NewArival
